// Its own module, free of imports: code outside the Backsolve tab (the linked OPM Calculator
// sync) needs the sheet names, and `constants.tsx` pulls in components that import the tab back.
export const BACKSOLVE_TABLE_NAMES = {
  BACKSOLVE_SUMMARY: 'backsolveSummary',
  BACKSOLVE: 'backsolve',
  MARKET_ADJUSTMENT: 'marketAdjustment',
  OPM_INPUTS: 'opmInputs',
  SECURITIES: 'securities',
  SOURCE_ROWS: 'sourceRows',
};
